export const defaultVeiculoEditar = {
  placa: "",
  chassi: "",
  renavam: "",
  uf: "",
};
